<div class="feature-container" *ngIf="features">
    <tyt-membership-feature 
        *ngFor="let feature of features"
        [feature]="feature"
        [class.active]="hasFeature(feature)"
        ></tyt-membership-feature>
</div>